import FiveStarReviews from './FiveStarReviews';

export default FiveStarReviews;
